export const baseURL = process.env.REACT_APP_BASE_API_URL;
export const baseCMSURL = process.env.REACT_APP_BASE_CMS_URL;
export const baseAppURL = process.env.REACT_APP_BASE_URL;